// extracted by mini-css-extract-plugin
module.exports = {"title":"Exhibition_title__8mhst","list":"Exhibition_list__rR3C6"};